import { FileStoreService } from '../../shared/_services/file-store.service';
import { RicercaPaginazione } from '../models/sendpersonale';
import { ServerPaginationService } from '../../shared/_services/server-pagination.service';
import { AziendeStoreService } from '../_service/aziende-store.service';
import { Azienda } from '../models/Azienda';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Permission } from "../../Login/_guards/Permission";
import { ClassicType } from "../../shared/models/ClassicType";
import { ApiRestService } from "../_service/api-rest.service";
import { environment } from 'src/environments/environment';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ImportAziendeComponent } from "../import-aziende/import-aziende.component";
import { debounceTime } from "rxjs/operators";
import { CampoUtility } from "../../shared/models/campo-aggiuntivo";
import { Color, hsl } from "d3";
@Component({
  selector: 'app-lista-aziende',
  templateUrl: './lista-aziende.component.html'
})
export class ListaAziendeComponent implements OnInit {
  environment = environment;
  dropdownSettings = {
    singleSelection: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    idField: 'id',
    textField: 'label',
    allowSearchFilter: false,
  };
  tipologieAsObj: ClassicType[];
  selectedItems: ClassicType[] = [];
  private subscriptions: Subscription = new Subscription();
  Lista: Azienda[] = [];
  Selected: Azienda = null;
  submittedricerca = false;
  cercaform: FormGroup;
  editable: boolean = false;
  showaddform: boolean = false;
  /**************************************
        Variabili paginazione
  **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4    // pagine da precaricare dal server
  collectionSize = 0;   // numero totale di elementi nell'array
  newpagegenerated = 0; // pagina per cui è stata fatta la richiesta al server
  type: string;
  filter: RicercaPaginazione = { page: 1, size: this.pagesizeserver * this.pageSize };
  hide: boolean = false;
  constructor(
    public permission: Permission,
    public aziendeStore: AziendeStoreService,
    private formBuilder: FormBuilder,
    private paginationService: ServerPaginationService,
    private route: ActivatedRoute,
    private router: Router,
    private filestore: FileStoreService,
    private apiRestService: ApiRestService,
    private modalService: NgbModal,
    public campoUtility: CampoUtility
  ) {
    this.route.queryParams
      .subscribe(params => {
        Object.getOwnPropertyNames(params)?.forEach(prop => {
          this.filter[prop] = params[prop];
          console.log('copy ' + params[prop] + ' to ' + 'this.filtro.' + prop)
        })
      }
      );
    this.cercaform = this.formBuilder.group({
      cerca: ['', Validators.required],
      size: [''],
    });
  }
  get f() { return this.cercaform.controls; }

  ngOnInit() {
    this.setupSearchDebouncer();
    if (this.environment.ClientiAddOn.ruolo)
      this.apiRestService.getRuoloClienti().subscribe(data => this.tipologieAsObj = data);
    this.subscriptions.add(this.aziendeStore.$listaAziende.subscribe((items) => {
      if (items !== null && items !== undefined) {
        this.Lista = items.data;
        this.collectionSize = items.total;
        this.Selected = null;
      }
    }));
    this.route.params.subscribe(data => {
      this.type = data['type'];
      this.refreshTable(1);
    })

    this.subscriptions.add(this.aziendeStore.$editable.subscribe((items) => this.editable = items));
    this.subscriptions.add(this.aziendeStore.$showAddForm.subscribe((items) => this.showaddform = items));
    this.cercaform.controls.size.patchValue(50);

  }

  sizeChanged() {
    this.cercaform.controls.cerca.setValue('');
    this.pageSize = parseInt(this.f.size.value);
    this.refreshTable(1);
  }
  LightenColor(color: Color, percent = 50) {
    var num = parseInt(color.toString().replace("#", ""), 16);
    if (num < 16750000)
      return hsl(0, 0, 100);
    else
      return hsl(0, 0, 0);
  };
  Search() {
    this.submittedricerca = true;
    if (this.cercaform.invalid) {
      this.refreshTable(1);
      return;
    }
    this.refreshTable(1);
    this.submittedricerca = false;
  }
  public debouncedInputValue = null;
  private searchDecouncer$: Subject<any> = new Subject();



  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(1000),
    ).subscribe((term: any) => {
      this.debouncedInputValue = Object.assign({}, term);
      this.Ricerca(this.debouncedInputValue);
    });
  }

  edit(val: Azienda) {
    if (this.permission.isPermitted('gestione-clienti') || environment.ClientiAddOn['menuCanReadonly']) {
      this.Selected = val;
      this.filestore.SelectSection('Clienti');
      this.aziendeStore.updateEditable(true);
      this.aziendeStore.updateShowAddForm(false);
      this.aziendeStore.updateSelectedAzienda(this.Selected);
      const splittedApiUrl = environment.apiUrl.split('/');
      const route = (environment['baseHref'] || splittedApiUrl.length > 4) && !location.origin.includes('localhost') && !location.origin.includes('192.168') && !location.origin.includes('84.247') ? `/${environment['baseHref'] ?? splittedApiUrl[3]}/listautenti/formazienda/` : '/listautenti/formazienda/'
      console.log(route + (this.type ?? '0') + '/' + this.Selected.id);
      window.open(route + (this.type ?? '0') + '/' + this.Selected.id, '_blank');
    }
  }
  delete(selectedContact) {
    if (confirm("Sicuro di voler eliminare questo elemento dalla lista?"))
      this.apiRestService.deleteCompany(selectedContact).subscribe(data => { this.refreshTable(1) });
  }
  add() {
    this.aziendeStore.updateShowAddForm(true);
    this.aziendeStore.updateEditable(false);
    this.aziendeStore.updateSelectedAzienda(new Azienda());
    const splittedApiUrl = environment.apiUrl.split('/');
    const route = (environment['baseHref'] || splittedApiUrl.length > 4) && !location.origin.includes('localhost') && !location.origin.includes('192.168') && !location.origin.includes('84.247') ? `/${environment['baseHref'] ?? splittedApiUrl[3]}/listautenti/formazienda/` : '/listautenti/formazienda/'

    console.log(`${route}${this.type ?? '0'}`);
    window.open(`${route}${this.type ?? '0'}`, '_blank');
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page, ruolo?) {
    this.route.queryParams
      .subscribe(params => {
        Object.getOwnPropertyNames(params)?.forEach(prop => {
          this.filter[prop] = params[prop];
          console.log('copy ' + params[prop] + ' to ' + 'this.filtro.' + prop)
        })
        this.filter.page = (page - 1) / this.pagesizeserver + 1;
        this.filter.size = this.pagesizeserver * this.pageSize;
        this.filter.ruolo = ruolo ?? undefined;
        if (this.type)
          this.filter.ruolo = this.type.toUpperCase();
        this.searchDecouncer$.next(this.filter);
      }
      );

  }

  Ricerca(filter) {
    this.aziendeStore.getListaAziende(this.filter);
  }

  typechange() {
    this.refreshTable(1, this.selectedItems?.length > 0 ? this.selectedItems[0]?.id : undefined)
  }

  enable(co) {
    this.apiRestService.enableAziende(co).subscribe(data => this.refreshTable(1, this.selectedItems[0]?.id))
  }
  AddAdhoc(co) {
    this.apiRestService.SendToAdhoc(co).subscribe(data => this.refreshTable(1, this.selectedItems[0]?.id))
  }


  order(campo: any) {

  }

  headShow(campo): boolean {
    if (!campo['filtertype'] && !campo['filternottype'])
      return this.campoUtility.Show(campo, this.filter, false);
    var filterType = !campo['filtertype'] || (!Array.isArray(campo['filtertype']) && (campo['filtertype'] == this.type || campo['filtertype'] == this.filter)) || (Array.isArray(campo['filtertype']) && campo['filtertype']?.some(x => x == this.type || x == this.filter))
    var filternotType = !campo['filternottype'] || (!Array.isArray(campo['filternottype']) && campo['filternottype'] != this.type && campo['filternottype'] != this.filter) || (Array.isArray(campo['filternottype']) && (campo['filternottype']?.every(x => x != this.type && x != this.filter)))
    return filterType && filternotType;
  }

  Warning(cliente) {
    var mancanti: { nome: string, field: string, mex: string }[] = this.environment.ClientiAddOn['alertInfoMancanti']?.filter((x) => !cliente[x.field]);
    if (!mancanti?.length) return '';
    var output = '';
    mancanti.forEach((info: { nome: string, field: string, mex: string }) => {
      output += ` ${info.mex ?? "il campo " + info.nome + " non è stato inserito"} \n`
    })
    return output;
  }
}
